import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8a197b7a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=8a197b7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a197b7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a197b7a')) {
      api.createRecord('8a197b7a', component.options)
    } else {
      api.reload('8a197b7a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8a197b7a&scoped=true", function () {
      api.rerender('8a197b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coupon/index.vue"
export default component.exports